export default __webpack_public_path__ + "static/media/Hiring-Staff.ccc63a4f.jpg";